import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { BREADCRUMBS_IDS } from "../../constants/BreadcrumbsIds";
import { PAGE_URLS } from "../../constants/PageUrls";
import { TEST_IDS } from "../../constants/TestIds";
import { useCustomer } from "../useCustomer";
import { useListBreadcrumbs } from "../useListBreadcrumbs";

import type { BreadcrumbItem } from "modules/common";
import type { ObjectWithId } from "utils/ObjectWithId";

export function useDetailsBreadcrumbs() {
  const { id } = useParams<ObjectWithId>();
  const listBreadcrumbs = useListBreadcrumbs();
  const { customer } = useCustomer();
  const { name } = customer ?? {};

  return useMemo(
    (): BreadcrumbItem[] => [
      ...listBreadcrumbs,
      {
        id: BREADCRUMBS_IDS.details,
        title: name,
        url: PAGE_URLS.getDetails(id),
        "data-testid": TEST_IDS.breadcrumbDetails,
      },
    ],
    [listBreadcrumbs, id, name]
  );
}
